// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"230":"LocaleMessagePopover","650":"LocaleMessageModal"}[chunkId] + "." + {"230":"58276b8cd2d907edcd88","650":"3694a7d979001f59e647"}[chunkId] + ".js";
};